import { Injectable } from '@angular/core';
import { ConfigBaseFilter, SimpleConfigBaseFilter } from 'gung-list';
import { Customer } from 'gung-standard';
import { JeevesCustomerListConfigService } from 'gung-standard-jeeves';

export class ColmecPartnerCustomerFilter extends SimpleConfigBaseFilter<Customer> {
  getName(): string {
    return 'PARTNER';
  }

  getOptionIds(item: Customer): string[] {
    return [!!item.extra?.kus?.q_partner_boolean ? 'YES' : 'NO'];
  }

  getOptionName(key: string): string {
    return key;
  }

  isActiveFromStart = () => true;
}

@Injectable({
  providedIn: 'root'
})
export class ColmecCustomerListConfigService extends JeevesCustomerListConfigService {
  getFilters(): ConfigBaseFilter<Customer>[] {
    const superFilters = super.getFilters();
    return [...superFilters, new ColmecPartnerCustomerFilter()];
  }
}
